export enum NotificationChannel {
    Email = "Email",
    SMS = "SMS",
}
